import FormRecoverPassword from "../../common/security/FormRecoverPassword";

const CambiarPassword = () => {
    return (<>
        <FormRecoverPassword/>
    </>)
}
export default CambiarPassword;